import { DELETE } from "./utils";

/**
 * Delete a rapid data.
 *
 * This endpoint:
 * 1. Deletes the Rapid Data
 * 2. Deletes the Rapid Data's Datasets
 * 3. Deletes the Rapid Data's Workflow
 */
export async function deleteRapidData(rapidDataId: string): Promise<{ success: boolean }> {
    return DELETE(`/api/rapiddata/${rapidDataId}`, {});
}
